// The one FNV-1a string hash of the client.
//
// The arcade deck seeds a procedural sea with it, the mod pictures key a
// picture by it and the chronicle picks a sentence variant by it. Each one
// carried its own copy. This leaf imports nothing.
//
// The hash runs over the UTF-16 code units of the string, not over UTF-8
// bytes. `ui/portrait/seed.ts` hashes UTF-8 bytes, so it keeps its own loop.

/** 32-bit FNV-1a over the UTF-16 code units of `text`, unsigned. */
export function fnv1a(text: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}
